// extracted by mini-css-extract-plugin
export default {"downloadButton":"ApplyOnlineStatusChangeContent_downloadButton__VqFWa"};